import * as ApiConst from '../constants/Api';

export const getSrc = (imgId, type) => {
    return type !== undefined ? `${ApiConst.BASE_IMG_URL}/${imgId}/${type}` : `${ApiConst.BASE_IMG_URL}/${imgId}`;
};

export const getUserAvatarSrc = userId => {
    return `${ApiConst.BASE_USER_AVATAR_URL}/${userId}/avatar`;
};



// WEBPACK FOOTER //
// ./src/utils/Image.js